export default __webpack_public_path__ + "static/media/hiking.9e8833e8.jpg";